/* eslint-disable jsx-a11y/anchor-is-valid */
import { useNavigate } from 'react-router-dom';
import styles from './BreadCrumb.module.scss';

const BreadCrumb = (props) => {
    const navigate = useNavigate();

    return (
        <div className={styles.breadCrumb}>
            <div className={styles.breadCrumbNav}>
                {props.list.map((item, i) => (
                    <div key={i} className={styles.breadCrumbItem}>
                        <a
                            className={styles.breadCrumbLink}
                            onClick={item.to ? () => navigate(item.to, { replace: true }) : null}
                        >
                            {item.label}
                        </a>
                    </div>
                ))}
            </div>
        </div>
    );
};

BreadCrumb.defaultProps = {
    list: [],
};

export default BreadCrumb;
